import React, {Component} from 'react';
import {Grid, Col, Row, Button, FormControl} from 'react-bootstrap';
import _  from 'lodash';

import Select   from 'react-select'
   import config from  '../../../config';
import {prepareSelectOptionsList} from 'util/Utils';



export default class AdminGBGProductSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        this.subcategoriesList =  _.sortBy(prepareSelectOptionsList(
            _.filter(this.props.allCategories,function (category) {
                return category.AncestorCategories.length > 0
            }),
            {
                label: 'CategoryName',
                value: '_id'
            }), 'label')
        this.categoriesList = _.sortBy(prepareSelectOptionsList(
            _.filter(this.props.allCategories,function (category) {
                return category.AncestorCategories.length == 0
            }),
            {
                label: 'CategoryName',
                value: '_id'
            }), 'label')
        var selectedCategory = ''
        var filterOptions = {
            Brands:   _.isArray(_.get(this.props.location, 'query.Brands', [])) ? _.map(_.get(this.props.location, 'query.Brands', []), function (item) {
                return {value:item, label:item}
            })  : [  {value:  _.get(this.props.location, 'query.Brands'), label:_.get(this.props.location, 'query.Brands')}],
            perPage: _.isUndefined(this.props.location.query.perPage) ? config.table.numberPerPage : this.props.location.query.perPage,
            searchText: _.isUndefined(this.props.location.query.searchText) ? '' : this.props.location.query.searchText,
            upcCodeText: _.isUndefined(this.props.location.query.upcCodeText) ? '' : this.props.location.query.upcCodeText,
            Type: _.isUndefined(this.props.location.query.Type) ? '' : this.props.location.query.Type,
            ActiveMostWantedGBGProduct: _.isUndefined(this.props.location.query.ActiveMostWantedGBGProduct) ? null : this.props.location.query.ActiveMostWantedGBGProduct
        }
        if (!_.isUndefined(this.props.location.query.Category)){
           var foundCategory =  _.find(this.props.allCategories, function (category) {
               return  category.AncestorCategories.length == 0 &&  this.props.location.query.Category == category.TagName
           }.bind(this))
            if ( foundCategory) {
                selectedCategory = foundCategory._id
                this.subcategoriesList =  _.sortBy(prepareSelectOptionsList(
                    _.filter(this.props.allCategories,function (category) {
                         return category.AncestorCategories.length > 0 && _.includes(_.map(category.AncestorCategories,'CategoryID'), selectedCategory)
                    }),
                    {
                        label: 'CategoryName',
                        value: '_id'
                    }), 'label')
            }
       }
        var selectedSubcategory = ''
        if (!_.isUndefined(this.props.location.query.Subcategory)){
            var foundSubcategory =  _.find(this.props.allCategories, function (category) {
                return  category.AncestorCategories.length > 0 &&  this.props.location.query.Subcategory == category.TagName
            }.bind(this))
            selectedSubcategory = foundSubcategory? foundSubcategory._id:''
        }
        console.log('selectedCategory', selectedCategory  );
        console.log('selectedSubcategory', selectedSubcategory  );
        if (selectedCategory) {
            filterOptions.selectedCategory = selectedCategory
            filterOptions.Category = foundCategory.TagName
        }
        if (selectedSubcategory) {
            filterOptions.selectedSubcategory = selectedSubcategory
            filterOptions.Subcategory = foundSubcategory.TagName
        }
        this.state = {
              filterOptions: filterOptions
        };
     };

    onChangePerPageNumber(option) {
        this.setState({'filterOptions': {...this.state.filterOptions, perPage: option.value}}, function () {
            this.props.search();
        });
    }

    getSearchParams(filtersChanged = {}) {
        var filterOptions = {...this.state.filterOptions, ...filtersChanged};
        var queryParams = {};
        if (filterOptions.perPage == 'all') {
            queryParams.all = true
        } else {
            queryParams.perPage = filterOptions.perPage;
        }
        if (filterOptions.searchText !== '') {
            queryParams.searchText = filterOptions.searchText;
        }
      if (filterOptions.upcCodeText !== '') {
        queryParams.upcCodeText = filterOptions.upcCodeText;
      }
        if (filterOptions.Type !== '') {
            queryParams.Type = filterOptions.Type;
        }
        if (filterOptions.Category ) {
            queryParams.Category = filterOptions.Category;
        }
        if (filterOptions.Subcategory ) {
            queryParams.Subcategory = filterOptions.Subcategory;
        }
        if (filterOptions.ActiveMostWantedGBGProduct != null ) {
            queryParams.ActiveMostWantedGBGProduct = filterOptions.ActiveMostWantedGBGProduct;
        }

        if (_.get(filterOptions, 'Brands', []).length ) {
            queryParams.Brands = _.map(filterOptions.Brands, 'value')
        }
        console.log('queryparams', queryParams  );
         return {queryParams}

    }


    onSearchTextChange(event) {
        var updateOptions = {...this.state.filterOptions, searchText: event.target.value};
        this.setState({'filterOptions': updateOptions});
    }

    onCategoryChange(option) {
        var selectedSubcategory = this.state.filterOptions.selectedSubcategory,
        Subcategory = this.state.filterOptions.Subcategory;
       if (option){
             this.subcategoriesList = _.sortBy(prepareSelectOptionsList(
               _.filter(this.props.allCategories,function (category) {
                   return category.AncestorCategories.length > 0 && _.includes(_.map(category.AncestorCategories,'CategoryID'), option.value)
               }),
               {
                   label: 'CategoryName',
                   value: '_id'
               }), 'label')
           var foundSelectedSubcategory = _.find( this.subcategoriesList, function (subcategoryOption) {
               return subcategoryOption.value == selectedSubcategory
           })

           if (!foundSelectedSubcategory){
               selectedSubcategory = '';
               Subcategory = ''
           }
        } else {
           this.subcategoriesList = _.sortBy(prepareSelectOptionsList(
               _.filter(this.props.allCategories,function (category) {
                   return category.AncestorCategories.length > 0
               }),
               {
                   label: 'CategoryName',
                   value: '_id'
               }), 'label');
       }
          this.setState({
                'filterOptions': {
                    ...this.state.filterOptions,
                    selectedCategory:   option ? option.value : '',
                    selectedSubcategory:selectedSubcategory,
                    Subcategory:Subcategory,
                    Category: option ? _.find(this.props.allCategories, function (category) {
                        return   option.value == category._id
                    })['TagName'] : '',
                },
             },
            function () {
                this.props.search();
            });
    }

    onSubcategoryChange(option) {

        this.setState({
                'filterOptions': {
                    ...this.state.filterOptions,
                    selectedSubcategory:   option ? option.value : '',
                    Subcategory: option ? _.find(this.props.allCategories, function (category) {
                        return   option.value == category._id
                    })['TagName'] : '',
                },
             },
            function () {
                this.props.search();
            });
    }

    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.search();
        }
    }

    render() {
           var self = this;
         return (
            <div className="product-search-block">
                <Row className="show-grid">
                    <Col md={4} xs={4} className="top10">
                        <Button className="btn btn-primary" onClick={this.props.onSelectAllRecordsChange}>
                            { this.props.adminGBGProducts.selectedProducts.length ? 'Clear selection' : 'Select all' }
                        </Button>
                    </Col>
                </Row>
                <Row  >

                    <Col md={3} xs={3} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Per Page"
                            clearable={false}
                            options={config.perPageSelectOptions}
                            onChange={this.onChangePerPageNumber.bind(this)}
                            value={self.state.filterOptions.perPage}
                        />
                    </Col>
                </Row>
                <Row  >

                    {/*<Col md={3} xs={3} className="top10">*/}
                        {/*<Select*/}
                            {/*tabIndex="0"*/}
                            {/*placeholder="Per Page"*/}
                            {/*clearable={false}*/}
                            {/*options={config.perPageSelectOptions}*/}
                            {/*onChange={this.onFilterChange.bind(this)}*/}
                            {/*value={self.state.filterOptions.perPage}*/}
                        {/*/>*/}
                    {/*</Col>*/}
                    <Col md={3} xs={6} className="top10">
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.searchText}
                                     onKeyPress={this._handleKeyPress.bind(this)}
                                     onChange={this.onSearchTextChange.bind(this)} ref="searchText"
                                     placeholder="Search"/>
                    </Col>
                  <Col md={3} xs={6} className="top10">
                    <FormControl type="text"
                                 defaultValue={this.state.filterOptions.upcCodeText}
                                 onKeyPress={this._handleKeyPress.bind(this)}
                                 onChange={(event)=>{
                                   var updateOptions = {...this.state.filterOptions, upcCodeText: event.target.value};
                                   this.setState({'filterOptions': updateOptions});
                                 }}
                                 placeholder="UPC Code"/>
                  </Col>
                    <Col xs={6} md={3} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Brands"
                            clearable={true}
                            multi
                        options={this.props.allBrands}
                             onChange={(selectedOptions)=> {
                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        Brands: selectedOptions
                                    }
                                }, function () {
                                    this.props.search();
                                });
                            }}
                            value={self.state.filterOptions.Brands}
                        />

                    </Col>
                    <Col xs={6} md={3} className="top10">
                             <Select
                                tabIndex="0"
                                placeholder="Category"
                                clearable={true}
                                options={this.categoriesList}
                                onChange={this.onCategoryChange.bind(this)}
                                value={self.state.filterOptions.selectedCategory}
                            />

                    </Col>

                    <Col xs={6} md={3}  className=" top10">
                         <Select
                            tabIndex="0"
                            clearable={true}
                            placeholder="Most Wanted"
                            options={[
                                {value: true, label: 'Most Wanted'},
                                {value: false, label: 'Not so Popular'}
                            ]}
                            onChange={(option) => {
                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        ActiveMostWantedGBGProduct: option ? option.value : null
                                    }
                                }, function () {
                                    this.props.search();
                                });
                            }}
                             value={self.state.filterOptions.ActiveMostWantedGBGProduct}
                        />
                    </Col>

                    <Col xs={6} md={3} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Subcategory"
                            clearable={true}
                            options={this.subcategoriesList}
                            onChange={this.onSubcategoryChange.bind(this)}
                            value={self.state.filterOptions.selectedSubcategory}
                        />

                    </Col>
                    <Col xs={6} md={3} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Type"
                            clearable={true}
                            options={[{ 'value':'Public', label:'Public'},{ 'value':'Seller', label:'Seller'}]}
                            onChange={ option=>{this.setState({
                                'filterOptions': {
                                ...this.state.filterOptions,
                                Type:   option ? option.value : '',
                            },
                            },
                                function () {
                                this.props.search();
                            });
                            }}
                            value={self.state.filterOptions.Type}
                        />

                    </Col>
                    <Col md={3} xs={6} className="top10">
                        <button className="btn btn-primary" disabled={this.props.pending} onClick={(event) => self.props.search({page: 1})}
                                type="button">
                            Search
                        </button>
                    </Col>
                    <Col md={3} xs={6} className="pull-right top10">
                        <button className="pull-right btn btn-primary" onClick={(event) => self.props.addNewGBGProduct()}
                                type="button">
                            Add
                        </button>
                    </Col>
                </Row>

            </div>
        );

    }
}



